import React, { Fragment } from "react";
import Select from "react-select";
import loadImage from "blueimp-load-image";
import classnames from "classnames";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import { getaddress } from "../../../api/UserApi";
import TimeInput from "../../../components/TimeInput";
import TimePicker from "../../../components/TimePicker";
import Firebase from "../../../firebasehelper";
import { TerritoryOptions, CurrencyOptions } from "../../../Constants/retailer";
import { ContentTypes } from "../../../Constants/selections";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import { UPLOADING_VIDEO, UPLOADING_IMAGE } from "../../../Constants/string";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import "./index.css";
import { days } from "../../../Constants/times";

const types = [
  { label: "Physical", value: "physical" },
  { label: "Streaming", value: "streaming" },
];
const redemptionTypes = [
  { label: "Ticketed", value: "ticket" },
  { label: "RSVP", value: "rsvp" },
];
const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 250,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};
class AddEventModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      postcode: "",
      building: "",
      description: "",
      address: { formatted_address: "" },
      error_msg: "",
      token: 0,
      price: null,
      territory: TerritoryOptions[0],
      finding_address: false,
      selectedDay: { value: 0, label: "Sunday" },
      type: { value: "physical", label: "Physical" },
      redemptionType: { value: "rsvp", label: "RSVP" },
      isrecurring: true,
      start_time: { hh: "00", mm: "00", of: "am", utc: 0 },
      end_time: { hh: "00", mm: "00", of: "am", utc: 0 },
      loading: false,
      loading_script: "",
      mediaUrl: "",
      purchaseType: "quickbuy",
      article: null,
    };
  }
  componentDidMount() {
    const { territory = TerritoryOptions[0] } = this.props;
    this.setState({ territory });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.territory !== this.props.territory) {
      this.setState({ territory: this.props.territory });
    }
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.setState({ selectedDate: this.props.selectedDate });
    }
  }
  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };
  handleSetRecurring = (value) => () => {
    this.setState({
      isrecurring: value,
    });
  };
  handleSetPayMethod = (value) => () => {
    this.setState({ purchaseType: value });
  };
  handleSelectChange = (selectedDay) => {
    this.setState({ selectedDay });
  };
  handleTypeSelectChange = (type) => {
    this.setState({ type });
  };
  handleRedemptionTypeSelectChange = (redemptionType) => {
    this.setState({ redemptionType });
  };
  handleSelectArticle = (article) => {
    this.setState({ article });
  };
  handleContentTypeSelectChange = (contentType) => {
    this.setState({ contentType });
  };
  handleChangeStartTime = (time) => {
    this.setState({ start_time: time });
  };
  handleChangeEndTime = (time) => {
    this.setState({ end_time: time });
  };
  handleSetMediaURL = (media_url) => {
    this.setState({ mediaUrl: media_url });
  };
  handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    this.setState({ loading_script });
  };
  handleUploadError = (error) => {
    this.setState({ loading: false, loading_script: "" });
  };
  checkValidation = () => {
    const {
      title,
      token,
      address,
      date,
      isrecurring,
      building,
      description,
      selectedDate,
      type,
    } = this.state;
    const date_validation = isrecurring ? true : date;
    const title_validation = title ? true : false;
    const address_validation =
      type.value === "physical" ? (address ? true : false) : true;
    const token_validation = token ? true : false;
    const building_validation =
      type.value === "physical" ? (building ? true : false) : true;
    const description_validation = description ? true : false;
    const validation =
      title_validation &&
      address_validation &&
      token_validation &&
      building_validation &&
      description_validation &&
      (date_validation || selectedDate);
    return validation;
  };
  findAddress = () => {
    const { postcode } = this.state;
    this.setState({ finding_address: true });
    getaddress(postcode)
      .then((res) => {
        if (res.status === "OK") {
          const address = res.results[0];
          this.setState({ address, error_msg: "" });
        } else {
          this.setState({
            error_msg: "There isn't matching address.",
            address: "",
          });
        }
        this.setState({ finding_address: false });
      })
      .catch((err) => {
        this.setState({
          error_msg:
            "Sorry we have some server problem. Try again later please.",
        });
      });
  };
  createEvent = () => {
    const {
      title,
      token,
      postcode,
      address,
      isrecurring,
      selectedDay,
      start_time,
      end_time,
      type,
      date,
      building,
      description,
      selectedDate,
      contentType,
      mediaUrl,
      purchaseType,
      redemptionType,
      price,
      article,
    } = this.state;
    console.log("date", date);
    const { createEvent } = this.props;

    let time = null;
    let payload = {
      title,
      type: type.value,
      address: { ...address, postcode, building },
      start_time,
      end_time,
      isrecurring,
      description,
      selectedDate,
      token: Number(token),
      media_type: contentType.value,
      media_url: mediaUrl,
      purchaseType,
      redemptionType: redemptionType.value,
      price,
      article: article ? article.value : null,
    };
    if (!isrecurring) {
      const { hh, mm, of, utc } = start_time;
      let hours = Number(hh);
      let minutes = Number(mm);
      if (of === "pm" && hours < 12) hours = hours + 12;
      if (of === "am" && hours === 12) hours = hours - 12;
      let m = moment();
      m.utcOffset(utc);
      const new_date = new Date(
        `${date}T${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:00`
      );
      const newDate = moment(new_date);
      m.set(newDate.toObject());
      time = m.valueOf(); //m.toDate();
      payload.time = time;
      payload.date = date;
      console.log("time", moment(time).toDate());
      console.log("date", date);
    } else {
      payload.day = selectedDay.value;
    }
    createEvent(payload);
  };
  onChangeTime = (obj) => {
    const { selectedDate } = this.state;
    const { hh, mm, of } = obj;
    let hours = hh;
    let newMoment = moment(selectedDate);
    if (of === "pm" && hh !== 12) hours = hh + 12;
    newMoment.set("hour", hours);
    newMoment.set("minute", mm);
    this.setState({ selectedDate: newMoment });
  };
  uploadContent = (contentType) => async (mediaContent) => {
    const uploadFolder = "events";
    const title = new Date().getTime().toString();
    if (contentType === GIF_UPLOAD) {
      this.setState({ loading: true, loading_script: UPLOADING_IMAGE });
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      this.setState({ loading: false });
      this.handleSetMediaURL(gif_url);
    } else if (contentType === IMAGE_UPLOAD) {
      this.setState({ loading: true, loading_script: UPLOADING_IMAGE });
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      this.setState({ loading: false });
      this.handleSetMediaURL(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      this.setState({ loading: true, loading_script: UPLOADING_VIDEO });
      uploadTask.on(
        "state_changed",
        this.handleUploadProgress,
        this.handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            this.setState({ loading: false, loading_script: "" });
            this.handleSetMediaURL(downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      this.handleSetMediaURL(mediaContent);
    }
  };
  render() {
    const {
      title,
      token,
      postcode,
      finding_address,
      address,
      error_msg,
      selectedDay,
      isrecurring,
      type,
      redemptionType,
      date,
      price,
      building,
      description,
      selectedDate,
      contentType,
      purchaseType,
      loading_script,
      loading,
      article,
    } = this.state;
    const { articles } = this.props;
    return (
      <div
        className="modal fade add-event-dialog"
        id="add_event_modal_old"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-event-content">
            <div className="modal-header">
              <h5 className="modal-title">Add a event</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 add-event-dialog-body">
              <p className="add-event-title">Type</p>
              <div className="form-group">
                <Select
                  value={type}
                  onChange={this.handleTypeSelectChange}
                  options={types}
                  styles={Styles}
                  placeholder="Type"
                />
              </div>
              <p className="add-event-title">Redemption</p>
              <div className="form-group">
                <Select
                  value={redemptionType}
                  onChange={this.handleRedemptionTypeSelectChange}
                  options={redemptionTypes}
                  styles={Styles}
                  placeholder="Redemption type"
                />
              </div>
              <p className="add-event-title">Event name</p>
              <input
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("title")}
                value={title}
              />
              {type.value === "physical" && (
                <React.Fragment>
                  <p className="add-event-title">Address</p>
                  <div className="row-div">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="PostCode"
                      value={postcode}
                      onChange={this.handleInputChange("postcode")}
                    />
                    <button
                      className="btn btn-green"
                      onClick={this.findAddress}
                    >
                      Find Address
                    </button>
                  </div>
                  {finding_address && (
                    <i className="fa fa-2x fa-sync fa-spin text-muted" />
                  )}
                  {!finding_address && (
                    <p>{error_msg ? error_msg : address.formatted_address}</p>
                  )}
                  <p className="add-event-title">Building Name/Number</p>
                  <input
                    className="form-control form-control-md form-control-alt"
                    onChange={this.handleInputChange("building")}
                    value={building}
                  />
                </React.Fragment>
              )}
              {type.value === "streaming" && (
                <p className="add-event-title">Live Stream Event</p>
              )}
              <p className="add-event-title">Article</p>
              <div className="form-group">
                <Select
                  value={article}
                  onChange={this.handleSelectArticle}
                  options={[{ label: "No Tag", value: null }].concat(
                    articles.map((article) => ({
                      value: article.id,
                      label: article.title,
                    }))
                  )}
                  styles={Styles}
                  placeholder="Tag a article"
                  noOptionsMessage={() => "No Tag"}
                ></Select>
              </div>
              <p className="add-event-title">Media</p>
              <div className="form-group">
                <Select
                  value={contentType}
                  onChange={this.handleContentTypeSelectChange}
                  options={ContentTypes}
                  styles={Styles}
                  placeholder="Media Type"
                />
              </div>
              {contentType && (
                <div className="input-container mb-2">
                  {contentType.value === YOUTUBE_URL && (
                    <YoutubeInput
                      onChangeContent={this.uploadContent(YOUTUBE_URL)}
                    />
                  )}
                  {contentType.value === IMAGE_UPLOAD && (
                    <ImageUpload
                      onChangeContent={this.uploadContent(IMAGE_UPLOAD)}
                    />
                  )}
                  {contentType.value === GIF_UPLOAD && (
                    <ImageUpload
                      isGif={true}
                      onChangeContent={this.uploadContent(GIF_UPLOAD)}
                    />
                  )}
                  {contentType.value === VIDEO_UPLOAD && (
                    <VideoUpload
                      onChangeContent={this.uploadContent(VIDEO_UPLOAD)}
                    />
                  )}
                </div>
              )}
              <Fade
                in={loading}
                style={{
                  transitionDelay: loading ? "800ms" : "0ms",
                }}
                unmountOnExit
              >
                <Fragment>
                  <p>{loading_script}</p>
                  <CircularProgress />
                </Fragment>
              </Fade>
              <p className="add-event-title">Description</p>
              <textarea
                maxLength="280"
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("description")}
                value={description}
              />
              <p className="bottom-small-text">Max characters: 280</p>
              <p className="add-event-title">Token reward</p>
              <input
                type="number"
                placeholder="0"
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("token")}
                value={token}
              />
              {!selectedDate && (
                <React.Fragment>
                  <p className="add-event-title">Recurring weekly</p>
                  <div className="option-container">
                    <p className="option-title">
                      <React.Fragment>
                        <b>Yes</b> or{" "}
                      </React.Fragment>
                      <b>No</b>
                    </p>
                    <div className="option-container">
                      <div
                        className={classnames("check-box", {
                          checked: isrecurring,
                        })}
                        onClick={this.handleSetRecurring(true)}
                      ></div>
                      <div
                        className={classnames("check-box", {
                          checked: !isrecurring,
                        })}
                        onClick={this.handleSetRecurring(false)}
                        style={{
                          marginLeft: "80px",
                        }}
                      ></div>
                    </div>
                  </div>
                  <p className="add-event-title">Select day</p>
                  {isrecurring && (
                    <div className="form-group">
                      <Select
                        value={selectedDay}
                        onChange={this.handleSelectChange}
                        options={days}
                        styles={Styles}
                        placeholder="Day of week"
                      />
                    </div>
                  )}
                  {!isrecurring && (
                    <div className="form-group">
                      <input
                        type="date"
                        className="form-control"
                        onChange={this.handleInputChange("date")}
                        value={date}
                      />
                    </div>
                  )}
                  <p className="add-event-title">Start time</p>
                  <TimeInput onChange={this.handleChangeStartTime} />
                  <p className="add-event-title">End time</p>
                  <TimeInput onChange={this.handleChangeEndTime} />
                </React.Fragment>
              )}
              {selectedDate && (
                <React.Fragment>
                  <p className="selectedDate-text">
                    {selectedDate.format("LLL")}
                  </p>
                  <TimePicker onChange={this.onChangeTime} />
                </React.Fragment>
              )}
              {redemptionType.value === "ticket" && (
                <React.Fragment>
                  <p className="add-event-title" style={{ marginTop: 20 }}>
                    One Off Buy or Monthly Subscription
                  </p>
                  <div className="option-container">
                    <div className="option-container">
                      <div
                        className={classnames("check-box", {
                          checked: purchaseType === "quickbuy",
                        })}
                        onClick={this.handleSetPayMethod("quickbuy")}
                      ></div>
                      <div
                        className={classnames("check-box", {
                          checked: purchaseType === "subscription",
                        })}
                        onClick={this.handleSetPayMethod("subscription")}
                        style={{
                          marginLeft: "80px",
                        }}
                      ></div>
                    </div>
                  </div>
                  <p className="add-event-title" style={{ marginTop: 20 }}>
                    Price
                  </p>
                  <input
                    className="form-control form-control-md"
                    onChange={this.handleInputChange("price")}
                    value={price}
                    style={{ width: 100 }}
                    placeholder="$0"
                    type="number"
                  />
                </React.Fragment>
              )}
              <div className="add-event-footer">
                <button
                  className="btn btn-green"
                  onClick={this.createEvent}
                  disabled={!this.checkValidation()}
                  data-dismiss="modal"
                >
                  Create
                </button>
                <button className="btn btn-orange" data-dismiss="modal">
                  Later
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddEventModal;



// WEBPACK FOOTER //
// ./src/screens/Event/AddEventModal/index.js